import { gql } from '@apollo/client'

const PRODUCT_EDGES = gql`
    fragment PRODUCT_EDGES on Product {
        title
        handle
        description(truncateAt: 50)
        images(first: 2) {
            edges {
                node {
                    src
                }
            }
        }
        variants(first: 1) {
            edges {
                node {
                    price
                    title
                    id
                }
            }
        }
    }
`

export const SEARCH_PRODUCTS = gql`
    query getProducts($query: String) {
        products(first: 10, query: $query) {
            edges {
                node {
                    ...PRODUCT_EDGES
                }
            }
        }
    }
    ${PRODUCT_EDGES}
`

export const GET_PRODUCT_BY_HANDLE = gql`
    query MyQuery($handle: String!) {
        productByHandle(handle: $handle) {
            images(first: 10) {
                edges {
                    node {
                        src
                    }
                }
            }
            title
            descriptionHtml
            variants(first: 10) {
                edges {
                    node {
                        price
                        id
                    }
                }
            }
        }
    }
`

export const GET_ALL_COLLECTIONS_PRODUCTS = gql`
    query getCollectionsProducts {
        collections(first: 10) {
            edges {
                node {
                    handle
                    image {
                        src
                    }
                    title
                    products(first: 10) {
                        edges {
                            node {
                                ...PRODUCT_EDGES
                            }
                        }
                    }
                }
            }
        }
    }
    ${PRODUCT_EDGES}
`

export const GET_PRODUCTS_NEW = gql`
    query getProducts {
        products(first: 10, sortKey: CREATED_AT, reverse: true) {
            edges {
                node {
                    ...PRODUCT_EDGES
                }
            }
        }
    }
    ${PRODUCT_EDGES}
`

export const GET_PRODUCTS_HOT = gql`
    query getProducts {
        products(first: 10, sortKey: BEST_SELLING, reverse: true) {
            edges {
                node {
                    ...PRODUCT_EDGES
                }
            }
        }
    }
    ${PRODUCT_EDGES}
`

export const GET_COLLECTIONS = gql`
    query MyQuery($limit: Int = 10) {
        collections(first: $limit) {
            edges {
                node {
                    title
                    handle
                    image {
                        src
                    }
                }
            }
        }
    }
`

export const GET_COLLECTION_BY_HANDLE = gql`
    query MyQuery($handle: String!, $limit: Int = 10) {
        collectionByHandle(handle: $handle) {
            title
            handle
            image {
                src
            }
            products(first: $limit) {
                edges {
                    node {
                        title
                        handle
                        images(first: 2) {
                            edges {
                                node {
                                    src
                                }
                            }
                        }
                        variants(first: 1) {
                            edges {
                                node {
                                    price
                                    title
                                    id
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const CUSTOMER_INFO = gql`
    query customer($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
            email
            firstName
            lastName
            addresses(first: 1) {
                edges {
                    node {
                        city
                        province
                        country
                        address1
                        address2
                    }
                }
            }
        }
    }
`

export const CUSTOMER_ADDRESS = gql`
    query MyQuery($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
            addresses(first: 10) {
                edges {
                    node {
                        address1
                        address2
                        city
                        country
                        firstName
                        lastName
                        id
                        phone
                        province
                        zip
                    }
                }
            }
        }
    }
`

export const CUSTOMER_ORDERS = gql`
    query orders($customerAccessToken: String!) {
        customer(customerAccessToken: $customerAccessToken) {
            orders(first: 10) {
                edges {
                    node {
                        totalPrice
                        totalTax
                        processedAt
                        orderNumber
                        lineItems(first: 10) {
                            edges {
                                node {
                                    title
                                    quantity
                                    variant {
                                        price
                                        image {
                                            src
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export const PRIVACY_POLICY = gql`
    query MyQuery {
        shop {
            termsOfService {
                body
                title
                url
            }
            privacyPolicy {
                body
                id
                title
                url
            }
        }
    }
`
